"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/popconfirm/style/css");

var _popconfirm = _interopRequireDefault(require("antd/es/popconfirm"));

require("antd/es/upload/style/css");

var _upload = _interopRequireDefault(require("antd/es/upload"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

require("antd/es/empty/style/css");

var _empty = _interopRequireDefault(require("antd/es/empty"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/typography/style/css");

var _typography = _interopRequireDefault(require("antd/es/typography"));

var _react = _interopRequireWildcard(require("react"));

var _icons = require("@ant-design/icons");

var _reactColor = require("react-color");

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var selectors = _interopRequireWildcard(require("../../../../redux/selectors"));

var _topicService = _interopRequireDefault(require("../../../../service/knowledgeCenter/topicService"));

var _topic = require("../../../../redux/topics/topic.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Text,
  Title
} = _typography.default;
const layout = {
  labelCol: {
    span: 10
  },
  wrapperCol: {
    span: 12
  }
};
const tailLayout = {
  wrapperCol: {
    offset: 10,
    span: 12
  }
};

const TopicDetail = props => {
  var _a, _b, _c;

  const [loading, setLoading] = (0, _react.useState)(false);
  const [imageUrl, setImageUrl] = (0, _react.useState)(((_a = props.topic) === null || _a === void 0 ? void 0 : _a.backgroundImageUri) || '');
  const [backgroundColor, setBackgroundColor] = (0, _react.useState)(((_b = props.topic) === null || _b === void 0 ? void 0 : _b.backgroundColor) || '');
  const [fields, setFields] = (0, _react.useState)([]);
  const [canDelete, setCanDelete] = (0, _react.useState)(false);

  const convertTopicToFields = () => {
    var _a, _b, _c, _d;

    return [{
      name: 'title',
      value: (_a = props.topic) === null || _a === void 0 ? void 0 : _a.title
    }, {
      name: 'id',
      value: (_b = props.topic) === null || _b === void 0 ? void 0 : _b.id
    }, {
      name: 'background_color',
      value: (_c = props.topic) === null || _c === void 0 ? void 0 : _c.backgroundColor
    }, {
      name: 'background_image_uri',
      value: (_d = props.topic) === null || _d === void 0 ? void 0 : _d.backgroundImageUri
    }];
  };

  (0, _react.useEffect)(() => {
    var _a, _b;

    setBackgroundColor(((_a = props.topic) === null || _a === void 0 ? void 0 : _a.backgroundColor) || '');
    setImageUrl(((_b = props.topic) === null || _b === void 0 ? void 0 : _b.backgroundImageUri) || '');
    setFields(convertTopicToFields());

    if (props.topic) {
      if (props.topic.children && props.topic.children.length > 0) {
        let isUsed = false;

        for (const topic of props.topic.children) {
          if (topic.articleCount > 0) {
            isUsed = true;
            break;
          }
        }

        setCanDelete(!isUsed);
      } else {
        setCanDelete(props.topic.articleCount === 0);
      }
    } else {
      setCanDelete(false);
    }
  }, [props.topic]);
  (0, _react.useEffect)(() => {
    setFields(convertTopicToFields());
  }, []);

  const onFinish = async values => {
    var _a;

    console.log('Success:', values);
    const updatedTopic = { ...props.topic,
      id: (_a = props.topic) === null || _a === void 0 ? void 0 : _a.id,
      title: values.title,
      backgroundColor,
      backgroundImageUri: imageUrl
    };
    props.onChange(false);

    try {
      await _topicService.default.updateTopic(updatedTopic);

      _message2.default.success('Saved successfully');

      props.loadResourceTopics();
    } catch (ex) {
      _message2.default.error('Error in saving data: ', ex.message);
    }
  };

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const beforeUpload = file => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

    if (!isJpgOrPng) {
      _message2.default.error('You can only upload JPG/PNG file!');
    }

    const isLt2M = file.size / 1024 / 1024 < 3;

    if (!isLt2M) {
      _message2.default.error('Image must be smaller than 3MB!');
    }

    return isJpgOrPng && isLt2M;
  };

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleChange = info => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }

    if (info.file.status === 'done') {
      // Get this url from response in real world.
      const uploadResponse = info.file.response;
      props.onChange(true);
      setLoading(false);
      setImageUrl(`/api${uploadResponse.link}`);
      getBase64(info.file.originFileObj, imageUrl => {});
    }
  };

  const handleBackgroundColorChange = color => {
    setBackgroundColor(color.hex);
    props.onChange(true);
  };

  const deleteBackgroundImage = () => {
    setImageUrl('');
  };

  const uploadButton = /*#__PURE__*/_react.default.createElement("div", null, loading ? /*#__PURE__*/_react.default.createElement(_icons.LoadingOutlined, null) : /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: 8
    }
  }, "Upload"));

  const onTitleChange = e => {
    const {
      value
    } = e.target;
    props.onChange(true);
  };

  const onDelete = async () => {
    props.onDelete();

    if (props.topic) {
      await _topicService.default.deleteTopic(props.topic.id);
    }

    _message2.default.success('Deleted successfully.  Please refresh.');

    props.loadResourceTopics();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 10
    }
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Topic Detail"), !props.topic && /*#__PURE__*/_react.default.createElement(_empty.default, {
    image: _empty.default.PRESENTED_IMAGE_SIMPLE,
    description: "Select a topic from left to see detail"
  }), !!props.topic && /*#__PURE__*/_react.default.createElement(_form.default, Object.assign({}, layout, {
    name: "basic",
    onFinish: onFinish,
    fields: fields,
    onFinishFailed: onFinishFailed
  }), props.topic.id && /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "ID",
    name: "id"
  }, /*#__PURE__*/_react.default.createElement(Text, {
    title: props.topic.parentTopicId ? `Parent ID: ${props.topic.parentTopicId}` : undefined
  }, props.topic.id)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Title",
    name: "title",
    rules: [{
      required: true,
      message: 'Please put title'
    }]
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    maxLength: 100,
    onChange: onTitleChange
  })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Background Image"
  }, /*#__PURE__*/_react.default.createElement(_upload.default, {
    name: "file",
    listType: "picture-card",
    showUploadList: false,
    action: "/api/a/upload/topic",
    beforeUpload: beforeUpload,
    onChange: handleChange,
    headers: {
      Authorization: `Bearer ${(_c = props.oidc.user) === null || _c === void 0 ? void 0 : _c.access_token}`
    }
  }, imageUrl ? /*#__PURE__*/_react.default.createElement("img", {
    src: imageUrl,
    alt: "Background Image",
    style: {
      width: '100%',
      backgroundColor
    }
  }) : uploadButton), imageUrl && /*#__PURE__*/_react.default.createElement(_popconfirm.default, {
    title: "Are you sure to delete background image?",
    onConfirm: deleteBackgroundImage,
    okText: "Yes",
    cancelText: "No"
  }, /*#__PURE__*/_react.default.createElement(_icons.DeleteOutlined, {
    style: {
      fontSize: 18
    }
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Background Color"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactColor.CompactPicker, {
    color: backgroundColor,
    onChangeComplete: handleBackgroundColorChange
  })), !!backgroundColor && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/_react.default.createElement(_popconfirm.default, {
    title: "Are you sure to delete background color?",
    onConfirm: () => setBackgroundColor(''),
    okText: "Yes",
    cancelText: "No"
  }, /*#__PURE__*/_react.default.createElement(_icons.DeleteOutlined, {
    style: {
      fontSize: 18
    }
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, Object.assign({}, tailLayout), /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    htmlType: "submit",
    style: {
      marginRight: 10
    }
  }, "Save"), canDelete && /*#__PURE__*/_react.default.createElement(_popconfirm.default, {
    title: "Are you sure to delete this topic?",
    onConfirm: onDelete,
    okText: "Yes",
    cancelText: "No"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "default"
  }, "Delete")))));
};

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  oidc: selectors.selectOidc
});

const mapDispatchToProps = dispatch => {
  return {
    loadResourceTopics: () => dispatch(_topic.loadResourceTopicsAsync.request())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TopicDetail);

exports.default = _default;